module.exports = __webpack_public_path__ + "static/media/nft-banner-img1.c064f965.svg";